import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import React, { useMemo } from 'react';
import { getProfileOptions } from 'widgets/estimatedTradeCost/components/options';

export function ProfileDropdown({
    benchmark,
    bottom,
    profile,
    onChanged,
}: {
    benchmark: string | undefined;
    bottom?: boolean;
    profile: string | undefined;
    onChanged: (nextProfile: string) => void;
}) {
    const profileOptions = useMemo(
        () => getProfileOptions(benchmark ?? ''),
        [benchmark]
    );

    return (
        <Dropdown
            className="profiles-dropdown"
            onChange={onChanged}
            value={profile}
            options={profileOptions}
            placeholder="Select a Profile"
            bottom={bottom}
        />
    );
}
